module.exports = __webpack_public_path__ + "static/media/unchecked.05f99acf.svg";